import { updatePhaseById } from '../../services/phases';
import { lineToPhaseDraft } from './phaseDraft';

const n = (v, d = 0) => parseFloat(v) || d;

/* Montants d'une phase issus de sa ligne vendue, avec les mêmes règles qu'à la conversion. */
export function phaseAmountsFromLine(l) {
  const d = lineToPhaseDraft(l);
  return {
    tjm: n(d.tjm),
    jours_total: n(d.jours_total),
    montant_global: n(d.montant_global),
    nb_devs: n(d.nb_devs, 1),
    correctif_qte: n(d.correctif_qte),
    correctif_unite: d.correctif_unite,
    evolutif_qte: n(d.evolutif_qte),
    evolutif_unite: d.evolutif_unite,
  };
}

/* Reporte les montants des lignes d'une affaire convertie sur les phases qui en sont issues : le
   budget se pilote depuis le CRM. Renvoie le nombre de phases mises à jour. */
export async function syncPhaseAmounts(lignes, clients) {
  const phases = (clients || []).flatMap((c) => c.phases || []);
  let updated = 0;
  for (const l of lignes || [])
    for (const ph of phases.filter((p) => p.ligneId === l.id)) {
      await updatePhaseById(ph.id, phaseAmountsFromLine(l));
      updated++;
    }
  return updated;
}
